import React from 'react'
import { PopUpContainer, PopUpHeader, PopUpTitle, PopUpContent, PopUpParagraph } from 'components/popup/startupModal/style'
import 'components/popup/style.css'
import { FormStartupOuterDiv } from '../style'

export interface ConfirmationModalProps {
  isAddResident: boolean
}

export const ConfirmationModal = ({ isAddResident }: ConfirmationModalProps): JSX.Element => {
  const message = isAddResident
    ? 'Tem certeza de que deseja adicionar esta startup ao seu ecossistema?'
    : 'Tem certeza de que deseja remover esta startup do seu ecossistema?'

  return (
    <FormStartupOuterDiv>
        <p>{message}</p>
    </FormStartupOuterDiv>
  )
}
